import { render, staticRenderFns } from "./ScheduleSubject.vue?vue&type=template&id=33c07b19&scoped=true"
import script from "@/views/Schedules/ScheduleSubject.ts?vue&type=script&lang=ts&external"
export * from "@/views/Schedules/ScheduleSubject.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Schedules/schedule-subject.scss?vue&type=style&index=0&id=33c07b19&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c07b19",
  null
  
)

export default component.exports